import { connect } from 'react-redux';
import Component from './component';
import setContactRedirectRoute from '../../actions/contacts/redirectroute';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  handleSetContactRedirectRoute: async (command) => {
    await dispatch(await setContactRedirectRoute(command));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
